import { Component, Input, Output,EventEmitter } from '@angular/core';
import { KeyValue } from '../../models/common';

@Component({
  selector: 'antera-software-kanban-filter-bar',
  templateUrl: './kanban-filter-bar.component.html',
  styleUrls: ['./kanban-filter-bar.component.scss']
})
export class KanbanFilterBarComponent {

  constructor() { }

  @Input() public filterList: KeyValue[] =  [];
  @Input() public showUpdateSearchFlag: boolean = false;
  @Input() public page: string = '';

  @Output() public onClearAll: EventEmitter<any> = new EventEmitter();
  @Output() public saveSearchResult: EventEmitter<any> = new EventEmitter();
  @Output() public onRemoveFilter: EventEmitter<any>  = new EventEmitter();
  @Output() public onUpdateExistingSearch: EventEmitter<any> = new EventEmitter();
  @Input() public mappingFields: any[] =  [];

  public removeBtn = true;

  /**
   * Clears the filter list and emits result.
   *
   * @returns {void}
   */
  public clearAll(): void {
    this.onClearAll.emit();
  }

  /**
   * Saves the search and emits result.
   *
   * @returns {void}
   */
  public saveSearch(): void{
    this.saveSearchResult.emit(this.filterList);
  }

  /**
   * Removes the filter and emits result.
   *
   * @returns {void}
   */
  public removeFilter(filter: KeyValue): void {
      this.onRemoveFilter.emit(filter);
  }

  /**
   * Updates the saved search.
   *
   * @returns {void}
   */
  public updateSavedSearch(): void {
    this.onUpdateExistingSearch.emit(this.filterList);
  }

}
